import React from 'react';
import { type UseFormRegisterReturn } from 'react-hook-form';
import styles from './Textarea.module.scss';

interface ITextarea {
	register: UseFormRegisterReturn<string>;
	isError?: boolean;
	classes?: {
		field?: string;
		textarea?: string;
	};
}
type TextareaProps = ITextarea &
	React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea: React.FC<TextareaProps> = ({
	register,
	isError,
	classes,
	...props
}) => {
	const { field, textarea } = classes ?? {};

	return (
		<label
			className={`
				${styles['field']}
				${isError ? styles['field_error'] : ''}
				${field ?? ''}
			`}
		>
			<textarea
				className={`
					${styles['field__textarea']}
					${textarea ?? ''}
				`}
				{...props}
				{...register}
			/>
		</label>
	);
};
